module.exports = __webpack_public_path__ + "img/certificate-bg.20230caf.png";